import React from 'react';
import { CustomSurveyWidget } from './CustomSurveyWidget/CustomSurveyWidget';
import EventsWidget from './EventsWidget';

export const CustomerRefUserWidgets = () => (
  <>
    <EventsWidget />
    <br />
    <CustomSurveyWidget />
  </>
);
